import { updateGhostText, updateIsSuggestionSetCompleteInternal } from '../actions/internalActions';
import { updateIsSuggestionSetComplete } from '../actions/publicActions';
import { getStore } from '../store/store';
import { orchestrator } from 'satcheljs';
export default orchestrator(updateIsSuggestionSetComplete, function (actionMessage) {
    var currentSuggestions = getStore().currentSuggestions;
    if (currentSuggestions) {
        // First, dispatch action to update the store.
        updateIsSuggestionSetCompleteInternal(actionMessage.isComplete);
        /**
         * After store update is complete, dispatch action to update ghost text
         * (since it's likely the first suggestion has changed) if suggestion
         * set is now complete.
         */
        if (actionMessage.isComplete) {
            updateGhostText();
        }
    }
});
//# sourceMappingURL=updateIsSuggestionSetCompleteOrchestrator.js.map